'use client';

import { useEffect } from 'react';

import { sendSentryBreadcrumb } from '@/app/_lib/sentry';
import { isClient } from '@/app/_utils/env';
import { useCitiboxData } from '@/hooks/useCitiboxData';
import { AnalyticsEvents } from '@/lib/google/AnalyticsEvents';
import { AnalyticsProperties } from '@/lib/google/AnalyticsProperties';
import { analyticsCouriers } from '@/lib/google/analytics';

const IsNavigatorOnline = () => {
  const citiboxData = useCitiboxData();
  useEffect(() => {
    // Sends analytics when the browser is online or offline.
    if (isClient()) {
      const handleOnlineChange = (ev: Event) => {
        analyticsCouriers.sendEvent(AnalyticsEvents.NAVIGATOR_OFFLINE, {
          [AnalyticsProperties.IS_ONLINE]: ev.type === 'online',
          [AnalyticsProperties.BOX_ID]: citiboxData.getBoxId() || '',
          [AnalyticsProperties.USER_AGENT]: navigator.userAgent
        });
        sendSentryBreadcrumb(
          'Internet connection status',
          'internet_connection_status',
          { is_online: ev.type === 'online', time: new Date().toISOString() },
          'info'
        );
      };

      window.addEventListener('online', handleOnlineChange);
      window.addEventListener('offline', handleOnlineChange);
      return () => {
        window.removeEventListener('online', handleOnlineChange);
        window.removeEventListener('offline', handleOnlineChange);
      };
    } else {
      return () => {};
    }
  }, []);

  return null;
};

export default IsNavigatorOnline;
